import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions, Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import { IRequestOptions } from './request-options.interface';
import { HttpInterceptor } from './http-interceptor.service';

@Injectable()
export class APIIRextService {
  public static readonly DEFAULT_URL = 'https://irlibrary.smartenit.io/v1';

  public defaultPath: string;
  public apiVersionUrl = '/v1';

  get apiCategoriesURL(): string {
    return 'categories';
  }

  get apiBrandsByCategoriesURL(): string {
    return 'brands';
  }

  get apiIndexesURL(): string {
    return 'indexes';
  }

  private _onServerError: Subject<any> = new Subject();

  public get onServerError(): Observable<any> {
    return this._onServerError.asObservable();
  }

  constructor(
    private http: Http,
  ) {
    this.defaultPath = APIIRextService.DEFAULT_URL;
  }

  public parseError(error: any) {
    try {
      let errorData = error;
      if (error._body && typeof error._body == 'string') {
        errorData = JSON.parse(error._body);
      } else if (error._body && typeof error._body == 'object') {
        errorData = error._body;
      }
      return errorData;
    } catch (parseError) {
      console.log('Response Parse error: ' + parseError.toString());
      return error;
    }
  }

  public getCategories(
    apiKey: string,
    data?: any,
    options?: IRequestOptions
  ): Observable<any> {
    const headers = new Headers();
    const innerOptions = new RequestOptions({ headers });

    let resourcePath = this.defaultPath;

    if (this.apiCategoriesURL) {
      resourcePath += '/' + this.apiCategoriesURL;
    }

    headers.append('x-api-key', apiKey);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    if (data) {
      resourcePath = this.addUrlParams(data, resourcePath);
    }

    return this.http
      .get(resourcePath, innerOptions)
      .timeout(30000)
      .map(this.extractData)
      .catch((error: any) => {
        console.log('Error', error);
        return this.handleError(error);
      });
  }

  public getBrandsByCategories(
    apiKey: string,
    data?: any,
    options?: IRequestOptions
  ): Observable<any> {
    const headers = new Headers();
    const innerOptions = new RequestOptions({ headers });

    let resourcePath = this.defaultPath;
    resourcePath += '/' + this.apiBrandsByCategoriesURL;

    headers.append('x-api-key', apiKey);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    if (data) {
      resourcePath = this.addUrlParams(data, resourcePath);
    }

    return this.http
      .get(resourcePath, innerOptions)
      .timeout(30000)
      .map(this.extractData)
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  public getIndexes(
    apiKey: string,
    data?: any,
    options?: IRequestOptions
  ): Observable<any> {
    const headers = new Headers();
    const innerOptions = new RequestOptions({ headers });

    let resourcePath = this.defaultPath;
    resourcePath += '/' + this.apiIndexesURL;

    headers.append('x-api-key', apiKey);
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    if (data) {
      resourcePath = this.addUrlParams(data, resourcePath);
    }

    return this.http
      .get(resourcePath, innerOptions)
      .timeout(30000)
      .map(this.extractData)
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  private addUrlParams(data: any, resourcePath: string): string {
    if (data) {
      const params = <any> [];
      const keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        params.push(keys[i] + '=' + encodeURIComponent(data[keys[i]]));
      }

      if (params.length > 0) {
        resourcePath += '?' + params.join('&');
      }
    }

    return resourcePath;
  }

  private extractData(res: Response) {
    return res.json();
  }

  private handleError(error: Response | any) {
    let errObj: any;
    if (error instanceof Response) {
      let body;
      try {
        body = error.json();
        if (body.error) {
          errObj = body.error;
        } else {
          errObj = body;
        }
      } catch (e) {
        console.log('Error:', e);
      }
    } else {
      errObj = error.message
        ? { message: error.message }
        : { message: error.toString() };
    }

    return Observable.throw(errObj);
  }
}
